export default "__VITE_ASSET__3194be8c__"